


export const DashedCircle = ({state, className, cmp}) => {
    return (
        <div 
           className={`${className} ${state ? 'md:w-[39px] md:h-[39px] lg:w-[50px] lg:h-[50px] xl:w-[70px] xl:h-[70px] ' : ' md:w-[49px] md:h-[49px]  lg:w-[69px] lg:h-[69px] xl:w-[89px] xl:h-[89px] '} w-[39px] h-[39px] ${cmp ? "bg-[url('/backGrounds/scale_dashes.svg')]":"bg-[url('/backGrounds/circle.svg')]"}  bg-cover`}
        />
    )
}